import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../../components/inputs/SearchInput';
import styles from './IncomingFilesHeader.styles';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';

export default function IncomingFilesHeader({
  title = 'Incoming Transmission File Log',
  onSearch,
  searchQuery,
  setSearchQuery,
}) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <MoveToInboxIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>{title}</Typography>
      </Box>

      <SearchInput
        value={searchQuery}
        onChange={setSearchQuery}
        onSearch={onSearch}
      />
    </Box>
  );
}
